/**
 * Whether the navigation now leaving this document is a locale switch.
 *
 * `LocaleManager.switchToLocale` changes language with a full page load, so a
 * page that wants to carry some of its in-memory state across that load has no
 * way, from the load itself, to tell it apart from an ordinary refresh — the URL
 * differs only by the locale prefix, which a refresh of an already-French page
 * has too.
 *
 * So the switch says so on the way out: the flag is set immediately before the
 * navigation, and an `unload`/`pagehide` handler runs after that and can read
 * it. Plain module state is enough, because the writer and the reader are the
 * same document; nothing is left behind for the next one.
 *
 * Used by Area Page V2's map, which keeps the user's zoom across a language
 * change but deliberately re-frames on the area for a refresh
 * (`map-viewport-storage`).
 */
let isSwitchingLocale = false;

/** Called by `LocaleManager.switchToLocale` just before it navigates. */
export function markLocaleSwitchNavigation(): void {
  isSwitchingLocale = true;
}

/** True only while a locale switch's own navigation is under way. */
export function isLocaleSwitchNavigation(): boolean {
  return isSwitchingLocale;
}

/** Test seam: no production caller, since the document is discarded instead. */
export function resetLocaleSwitchNavigation(): void {
  isSwitchingLocale = false;
}
